<template>
  <div>
    <!--    搜索部分-->
    <div style="margin-bottom: 10px">
      <el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch(enquiryForm)">查询
      </el-button>
      <el-button size="medium" style="font-size: 12px;" @click="Reset(enquiryForm)">重置</el-button>
      <el-button size="medium" type="warning" style="font-size: 12px;" @click="exportData">导出</el-button>
      <el-button size="medium" type="danger" style="font-size: 12px;" @click="printEvent()"> 打印</el-button>
    </div>
    <!-- //打印 -->
    <prints ref="prints" :tableData="tableData" :tableTh="tableTh" :tableTd="tableTd" v-show="false"></prints>
    <!--    表格部分-->
    <el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}"
              v-loading="loading" border id="tableDataId" size="mini">
      <el-table-column header-align="center" align="center" prop="id" label="序号" sortable>
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="user_name" label="盟友名称">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="mobile_phone" label="盟友手机号">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="merchant_platform" label="商户来源">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="hmf_merchant_id" label="商户编号">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="merchant_full_name" label="商户名称">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="status_text" label="门店状态">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="reject_reason" label="说明">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="update_time" label="更新时间">
      </el-table-column>
    </el-table>
    <!-- 分页部分 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                   :page-sizes="[20,50,100,200,500,1000]" :page-size="limit" :total="total"
                   layout="total, sizes, prev, pager, next, jumper" style="text-align: right"></el-pagination>
  </div>
</template>

<script>
import {
  export_json_to_excel
} from "@/excel/Export2Excel";
import prints from '@/components/print.vue'

export default {
  name: "storeInfo",
  components: {
    prints
  },
  data() {
    return {
      // 主页面部分
      loading: true, //列表loadding
      limit: 20, //条数
      total: 0, //总数
      tableData: [], //表格数据
      enquiryForm: {
        limit: 20,
        page: 1,
      },
      //打印
      tableTh: null,
      tableTd: null,
    }
  },
  created() {
    this.getData(this.enquiryForm)
    this.tableTh = ['序号', '盟友名称', '盟友手机号', '商户来源', '商户编号', '商户名称', '门店状态', '说明', '更新时间'];
    this.tableTd = ['id', 'user_name', 'mobile_phone', 'merchant_platform', 'hmf_merchant_id', 'merchant_full_name', 'status_text',
      'reject_reason', 'update_time'];
    this.$nextTick(() => {
      this.$refs.prints.prints();
    })
  },
  methods: {
    //打印
    printEvent() {
      this.$nextTick(() => {
        this.$refs.prints.prints();
        this.$refs.prints.print();
      })
    },

    // 主页面部分
    //搜索
    handleSearch(searchForm) {
      searchForm.page = 1;
      this.getData(searchForm);
    },
    //重置
    Reset(searchForm) {
      searchForm.page = 1;
      searchForm.user_name = '';
      this.getData(searchForm);
    },
    //分页
    handleCurrentChange(page) { //当前选中页
      this.enquiryForm.page = page;
      this.getData(this.enquiryForm);
    },
    handleSizeChange(limit) { //条数
      this.enquiryForm.limit = limit;
      this.enquiryForm.page = 1;
      this.getData(this.enquiryForm);
    },
    //获取数据
    getData(params) { //初始化数据
      this.loading = true;
      this.$api.post("/api/merchantstore/getMerchantPage?page=" + params.page, params, res => {
        if (res.status == 200) {
          let tableData = res.data;
          this.total = tableData.total; //总数
          this.tableData = tableData.list;
        } else {
          this.$message.error(res.msg);
        }
        //渲染结束后取消加载
        this.loading = false;
      })
    },
    // 导出
    exportData() {
      let th = ['序号', '盟友名称', '盟友手机号', '商户来源', '商户编号', '商户名称', '门店状态', '说明', '更新时间'];
      let excelData = ['id', 'user_name', 'mobile_phone', 'merchant_platform', 'hmf_merchant_id', 'merchant_full_name', 'status_text',
        'reject_reason', 'update_time'];
      let data = this.formatJson(excelData, this.tableData);
      let defaultTitle = '导出文件';
      export_json_to_excel(th, data, defaultTitle)
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
  }
}
</script>

<style scoped>
/deep/ .el-form-item__content .el-input-group {
  vertical-align: middle !important;
}

.code {
  cursor: pointer;
}

.code:hover {
  color: blue;
  text-decoration: underline;
}
</style>

